const state = {
  calendars : [],
  errors: null
}

export default state